module.exports = __webpack_public_path__ + "static/media/magic_interrupt.3a051c68.png";